<script setup lang="ts">
    import { useRoute } from 'vue-router';
    import { caseIdFromRoute, ROUTES } from '@/router';
    import { usePlansStore } from '@/views/plan/store/store';
    import PlanCard from '@/views/plan/PlanCard.vue';
    import { onBeforeUnmount } from 'vue';
    import { useSurgicalGuideOrders } from '@/stores/surgicalGuideOrders/store';
    import { useOrganisationProfile } from '@/stores/organisationProfile/store';
    import { useCaseSettings } from '@/stores/caseSettings/store';
    import { useSurgicalGuideCase } from '@/stores/surgicalGuide/caseStore';
    import PlanOrderSurgicalGuideModal from '@/views/plan/PlanOrderSurgicalGuideModal.vue';

    const store = usePlansStore();
    const route = useRoute();

    const caseId = caseIdFromRoute(route);
    await store.load(caseId);

    const caseSettings = useCaseSettings();

    const organisationProfile = useOrganisationProfile();
    if (organisationProfile.features.order_surgical_guide) {
        caseSettings.$reset();
        await caseSettings.loadExistingCase(caseId);
        await useSurgicalGuideCase().loadExistingCase(caseId);
        await useSurgicalGuideOrders().load(caseId);
    }

    onBeforeUnmount(() => {
        store.stopSync();
    });
</script>

<template>
    <v-layout>
        <app-sidebar>
            <router-link :to="{ name: ROUTES.HOME }">
                <app-link icon="mdi-arrow-left">Back to your Cases</app-link>
            </router-link>
        </app-sidebar>

        <app-main-view>
            <app-main-card>
                <div class="text-secondary-text text-heading-h3" data-testid="plans-page-heading">Formus Case Plans</div>
                <div class="text-subtitle-1 text-secondary" data-testid="plans-page-subtitle">
                    Formus Report and User Generated report in one place
                </div>
            </app-main-card>

            <PlanCard
                v-if="store.state.manualPlan"
                :project="store.state.project"
                :plan="store.state.manualPlan"
            />

             <PlanCard
                v-if="store.state.automatedPlan"
                :project="store.state.project"
                :plan="store.state.automatedPlan"
            />
        </app-main-view>

        <PlanOrderSurgicalGuideModal v-if="organisationProfile.features.order_surgical_guide" />
    </v-layout>
</template>
